import { Routes } from '@angular/router';
import { LayoutComponent } from '@app/shared/components/layout/layout.component';
import { SignOutComponent } from '@app/views/authorization/sign-out/sign-out.component';
import { companyRoute } from '@app/views/company/company.routing';

import { AuthGuard } from '@app/shared/guards/auth.guard';
import { NoAuthGuard } from '@app/shared/guards/no-auth.guard';
import { UrlSegment } from '@app/shared/types/enums/url-segment.enum';
import { userProfileNavigationGuard } from '@app/views/user-profile/user-profile-navigation.guard';
import { UserProfileComponent } from '@app/views/user-profile/user-profile.component';
import { AuthConfirmEmailSetPasswordComponent } from './views/authorization/confirm-email-set-password/confirm-email-set-password.component';
import { ForgotPasswordComponent } from './views/authorization/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './views/authorization/reset-password/reset-password.component';
import { SignInComponent } from './views/authorization/sign-in/sign-in.component';
import { HomeComponent } from './views/home/home/home.component';
import { reportsRoutes } from './views/reports/reports.routing';

// TODO: change to 'home' after dashboard view complete
const DEFAULT_ROUTE = UrlSegment.REPORTS;

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: DEFAULT_ROUTE },
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: DEFAULT_ROUTE },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: UrlSegment.SIGN_IN,
        component: SignInComponent
      },
      {
        path: UrlSegment.FORGOT_PASSWORD,
        component: ForgotPasswordComponent
      },
      {
        path: UrlSegment.RESET_PASSWORD,
        component: ResetPasswordComponent
      },
      {
        path: UrlSegment.ACTIVATION,
        component: AuthConfirmEmailSetPasswordComponent
      }
    ]
  },

  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: UrlSegment.HOME,
        component: HomeComponent
      },
      {
        path: `${UrlSegment.COMPANIES}/:company-id`,
        loadChildren: () => companyRoute
      },
      {
        path: UrlSegment.REPORTS,
        loadChildren: () => reportsRoutes
      },
      {
        path: UrlSegment.USER_PROFILE,
        component: UserProfileComponent,
        canDeactivate: [userProfileNavigationGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: UrlSegment.SIGN_OUT,
        component: SignOutComponent
      }
    ]
  },
  {
    path: 'dev',
    redirectTo: 'dev/design-system',
    pathMatch: 'full'
  },
  {
    path: 'dev/design-system',
    loadChildren: () => import('@app/views/dev/design-system/design-system.routes').then(m => m.designSystemRoutes)
  },

  { path: '**', redirectTo: UrlSegment.HOME }
];
